import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  CreateIntake,
  FindIntakes,
  FindMany,
  FindOne,
  Organisation,
  Intake,
  Option,
  PaginateResult,
  UpdateIntake,
} from '@univacity/shared/types';
import { Configuration } from '../config';

import { Params } from '@angular/router';
import { ObjectUtil } from '@univacity/shared/util';
import { format } from 'date-fns';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IntakeService {
  baseUrl: string;

  constructor(private http: HttpClient, private config: Configuration) {
    this.baseUrl = this.config.apiMainUrl + '/organisation';
  }

  create(organisationId: string, intake: CreateIntake) {
    return this.http.post<Intake>(
      `${this.baseUrl}/${organisationId}/intake`,
      intake
    );
  }

  findOne(organisationId: string, intake: string, query?: FindOne) {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<Intake>(
      `${this.baseUrl}/${organisationId}/intake/${intake}`,
      {
        params,
      }
    );
  }

  update(organisationId: string, intakeId: string, intake: UpdateIntake) {
    return this.http.patch<Intake>(
      `${this.baseUrl}/${organisationId}/intake/${intakeId}`,
      intake
    );
  }

  find(organisationId: string, query?: FindMany) {
    const params = new HttpParams({ fromObject: query as Params });
    return this.http.get<PaginateResult<Intake>>(
      `${this.baseUrl}/${organisationId}/intake`,
      {
        params,
      }
    );
  }

  delete(organisationId: string, intakeId: string): Observable<void> {
    return this.http.delete<void>(
      `${this.baseUrl}/${organisationId}/intake/${intakeId}`
    );
  }
  autoComplete =
    (organisation: string | Organisation, query: FindIntakes = {}) =>
    (
      search: string,
      page?: number
    ): Observable<{ options: Option[]; nextPage?: number | null }> => {
      const organisationId =
        typeof organisation === 'string' ? organisation : organisation._id;
      return this.http
        .get<PaginateResult<Intake>>(
          `${this.baseUrl}/${organisationId}/intake`,
          {
            params: ObjectUtil.removeEmptyProperties({
              search,
              page,
              select: ['season', 'startDate'],
              ...query,
            }),
          }
        )
        .pipe(
          map((res) => {
            const options: Option[] = res.docs.map((i) => ({
              label: `${i.season} ${format(new Date(i.startDate), 'yyyy')}`,
              value: i._id,
            }));
            return { options, nextPage: res.nextPage };
          })
        );
    };
}
